import { useState } from 'react' 
import { ModalAside } from '~components'
import { Props} from './interfaces'
import { FormPurchaseExtraUsers, FeedbackPurchaseUsersSuccess } from './components'
import { useTranslator } from '~hooks'
import {  Text } from '~constants/text'
import { useRequest } from 'ahooks'
import useToast from '~hooks/useToast'
import { Users } from '~services'
import { Values } from './components/Form/interfaces'
import { useAmplitude } from '~hooks'
import { AmplitudeEvent } from '~constants/amplitude'

function PurchaseExtraUsers({ open, onClose, onSuccess, rangePrice, renewDay, companyId }: Props) {
  const openToast = useToast()
  const { sendAmplitude } = useAmplitude()
  const [useFeedbackScreen, setFeedbackScreen] = useState(false)
  const [useAmountPurchased, setAmountPurchased] = useState<null | number>(null)
  const { translate } = useTranslator()

  function toggleFeedbackScreen() {
    setFeedbackScreen(!useFeedbackScreen)
  }

  function handleModalClose() {
    onClose?.()
  }

  const { loading, runAsync: purchaseUsers } = useRequest(Users.purchaseExtraUsers, {
    manual: true,
    onSuccess: handleSuccess,
    onError: handleError,
  })

  async function handleSubmit(values: Values) {
    const amount = parseInt(values.amount)

    sendAmplitude(AmplitudeEvent.USER_MANAGEMENT_CLICK_REGISTER_NEW_EXTRA_USERS, {
      company_id: companyId,
      message: 'Click no botão de comprar novos usuários extras',
      type: 'user_management_click_register_new_extra_users',
    })

    setAmountPurchased(amount)
    
    const data = {
      amount,
      product_slug: 'user'
    }

    await purchaseUsers(data)
  }

  function handleSuccess() {
    toggleFeedbackScreen()
  }

  function handleError() {
    openToast('error', 'Algo deu errado!')
  }

  return (
    <>
      <div className="portal-purchase-extra-users" />

      <ModalAside
        open={open}
        title={useFeedbackScreen? '' : translate(Text.EXTRA_USERS_PURCHASE)}
        onClose={handleModalClose}
        portalName="purchase-extra-users"
      >
        {useFeedbackScreen ? 
          <FeedbackPurchaseUsersSuccess onSuccess={onSuccess} amount={useAmountPurchased} /> :
          <FormPurchaseExtraUsers 
            loading={loading}
            companyId={companyId}
            rangePrice={rangePrice}
            renewDay={renewDay}
            handleSubmit={handleSubmit}
          />
        }
      </ModalAside>
    </>
  )
}

export default PurchaseExtraUsers